export enum RoomFilterChangeTypes{
    DateChange,
    RoomTypeChange,
    NightsChange,
    PriceRangeChange,
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-filter-change-types.enum.ts